import React, { useEffect, useRef, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import useQuery, { _get } from "../../Utils/Helper";
import { ButtonGroup } from "react-bootstrap";
import CommonSelect, { Option } from "../../../core/common/commonSelect";
import { acadamicTerms } from "../../../core/common/selectoption/selectoption";
import { SingleValue } from "react-select";
import AcademicYearSelect from "../../../core/common/AcademicYearSelect";

interface Class {
  class_name: string;
  count_students: number;
  status: string;
}
// interface ProcessProps{
//     class_name:string;
//     term:string;
//     academic_year:string;
// }
const FeesReceiptProcess: React.FC=() => {
  const routes = all_routes;
  const q = useQuery()
  const class_name = q.get("class_name")||"";
  const term = q.get("term")||"";
  const academic_year = q.get("academic_year")||"";

  const _form ={
    class_name,
    term,
    academic_year
}
  const [classes, setClasses] = useState<Class[]>([]);
    const [form, setForm] = useState(_form)
  useEffect(() => {
    _get(
      `payments?query_type=select-class-count&class_name=${form.class_name}&term=${form.term}&&academic_year=${form.academic_year}`,
      (res) => {
        if (res && res.data) {
          setClasses(res.data);
        } else {
          console.error("Unexpected response format:", res);
        }
      },
      (err) => {
        console.error("Error fetching classes:", err);
      }
    );
  }, [form.class_name, form.term, form.academic_year]);

  const columns = [
    {
      title: "Class",
      dataIndex: "class_name",
      render: (text: string, record: any, index: number) => <span>{text}</span>,
    },
    {
      title: "No of Students",
      dataIndex: "count_students",
      render: (text: number) => (
        <Link to="#" className="link-primary">
          {text}
        </Link>
      ),
    },
    {
      title: "Action",
      dataIndex: "count_students",
      render: (count_students: number, record: any) => (
        <ButtonGroup>
          <Link
          to={`${routes.classPayments}?class_name=${record.class_name}&term=First Term`}
          className="btn btn-success"
        >
          First Term
        </Link>
        <Link
          to={`${routes.classPayments}?class_name=${record.class_name}&term=Second Term`}
          className="btn btn-light"
        >
          Second Term
        </Link>
        <Link
          to={`${routes.classPayments}?class_name=${record.class_name}&term=Third Term`}
          className="btn btn-secondary"
        >
          Third Term
        </Link>
        </ButtonGroup>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              {/* <h3 className="page-title mb-1">Payment & Receipt</h3> */}
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Fees Collection</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Payment & Receipt
                  </li>
                </ol>
              </nav> */}
            </div>
          </div>
          {/* /Page Header */}

          {/* Students List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Payment & Receipt</h4>
							<div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <div className="row">
                <div className="col-md-6">

                  <div className="mb-3">
                    <label className="form-label">Academic Year</label>
                    <AcademicYearSelect
                      onChange={(year) => {
                        setForm((p) => ({ ...p, academic_year: year }))
                      }}
                      selectedYear={form.academic_year}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Term</label>
                    <CommonSelect
                      className="select"
                      options={acadamicTerms}
                      defaultValue={{
                        label: form.term,
                        value: form.term,
                      }}
                      handleChange={(newValue: SingleValue<Option>) =>
                        setForm((prev) => ({
                          ...prev,
                          term: newValue ? newValue.value : "",
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Student List */}
              <Table dataSource={classes} columns={columns} Selection={false} />
              {/* /Student List */}
            </div>
          </div>
          {/* /Students List */}
        </div>
      </div>
    </>
  );
};

export default FeesReceiptProcess;
